<template>
  <div>
    <div class="mask">
      <div class="viewLearningRecords">
        <div class="viewLearningRecords-play">
          <div class="viewTheRecordBox">
            <span class="md-close" @click="closeViewTheRecord">×</span>
            <span class="viewTheRecord">{{$t('i.personalInformation.viewLearningRecords')}}</span>
          </div>
          <div class="tableBox">
            <Table :columns="curriculumTitle" :data="courseContent"></Table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "viewLearningRecords",
    props:{
      courseContent: {}
    },
    data () {
      return {
        curriculumTitle: [
          {
            title: this.$t('i.viewLearningRecords.courseName'),
            key: 'name'
          },
          {
            title: this.$t('i.viewLearningRecords.courseType'),
            key: 'coursename'
          },
          {
            title: this.$t('i.viewLearningRecords.itsCurriculumSystem'),
            key: 'address'
          },
          // {
          //   title: this.$t('i.viewLearningRecords.completeState'),
          //   key: 'completestate'
          // },
          {
            title: this.$t('i.viewLearningRecords.lastLearningTime'),
            key: 'laststudy_time'
          }
          // ,{
          //   title: this.$t('i.viewLearningRecords.schedule'),
          //   key: 'schedule'
          // }
        ],
       // courseContent: []
      }
    },
    methods:{
      closeViewTheRecord(){
        this.$emit('closeLearningRecords');
      },
    },
  }
</script>

<style scoped>
  .mask{
    width: 100%;
    height: 100%;
    position: fixed;
    background: rgba(0,0,0,.10);
    top: 0;
    left: 0;
  }
  .viewLearningRecords{
    width: 100%;
    height: 500px;
  }
  .viewLearningRecords-play{
    width: 700px;
    height: 500px;
    margin: 100px auto;
    border-radius: 10px;
    border: 2px solid #ccc;
    background-color: #fff;
  }
  .viewTheRecordBox{
    width: 700px;
    height: 50px;
  }
  .viewTheRecord{
    display: block;
    font-size: 25px;
    text-align: center;
    line-height: 50px;
    margin-left: 30px;
  }
  .tableBox{
    width: 695px;
    height: 440px;
    float: left;
    overflow-y: auto;
  }
  .md-close{
    font-size: 45px;
    float: right;
    margin-right: 30px;
    line-height: 50px;
    cursor: pointer;
    color: #2d8cf0;
  }
</style>



// WEBPACK FOOTER //
// src/pages/viewLearningRecords/viewLearningRecords.vue